export function guessNavigatorLanguage(navigator: Navigator) {
  const languages = navigator.languages; // BCP47

  const hasDutch = languages.some((lang) => lang.toLowerCase().includes("nl"));
  if (hasDutch) return "nl";
  return "en";
}
